export default {
  path: '/app/splash',
  component: () => import('layouts/app/AppSplashLayout.vue'),
  children: [
    { path: '', name: 'AppSplashHome', component: () => import('pages/app/AppSplashPageSingle.vue') },
    { path: 'peg', name: 'AppSplashPeg', component: () => import('pages/app/AppSplashPagePeg.vue') },
    { path: 'triple', name: 'AppSplashTriple', component: () => import('pages/app/AppSplashPageTriple.vue') },
  ],
}
